module.exports = __webpack_public_path__ + "files/3a870ee8d8b822b3a2df7af06b90899c.png";